<app-content-container [isLoading]="isContactsStepLoading$ | async" [error]="contactsStepErrors$ | async">
  <p-card data-cy="shipping-address-container">
    <div
      class="mb-3 sm:mb-4 flex justify-content-between"
      [ngClass]="{
        'flex-row align-items-center': !editMode && ((addresses$ | async)?.length || 0) > 1,
        'flex-column align-items-start sm:flex-row sm:align-items-center':
          editMode || (!editMode && (addresses$ | async)?.length === 1)
      }"
    >
      <h3 class="my-0">
        Shipping Address<span *ngIf="(addPatientAddressTypeState$ | async)?.isLoading"
          ><p-progressSpinner styleClass="ml-2"></p-progressSpinner
        ></span>
      </h3>
      <button
        *ngIf="!editMode && ((addresses$ | async)?.length || 0) > 1"
        pButton
        type="button"
        label="Change"
        icon="mi-round mi-edit"
        class="p-button-text p-button-sm"
        (click)="switchToEdit()"
        data-cy="change-shipping-address-button"
        appClickEvent
        eventName="order_wizard_change_shipping_address"
      ></button>
      <button
        *ngIf="editMode || (addresses$ | async)?.length === 1"
        pButton
        type="button"
        label="Add New Address"
        icon="mi-round mi-add-circle-outline"
        class="p-button-text p-button-sm mt-2 sm:mt-0"
        (click)="showModal()"
        data-cy="new-address-button"
        appClickEvent
        eventName="order_wizard_add_new_address"
      ></button>
    </div>
    <div *ngIf="editMode && showErrors">
      <app-message
        *ngIf="!shippingAddressForm.get('selectedAddressId')?.valid"
        severity="error"
        data-cy="error-missing-selected-address-message"
      >
        Please select a shipping address
      </app-message>
    </div>
    <app-message
      *ngIf="(addPatientAddressTypeState$ | async)?.error"
      severity="error"
      data-cy="error-updating-address-default"
    >
      {{ (addPatientAddressTypeState$ | async)?.error?.uiMessage }}
    </app-message>
    <div>
      <p
        *ngIf="!editMode"
        class="p2 my-0"
        [innerHTML]="(reorder$ | async)?.shippingAddress | formatAddress"
        data-cy="shipping-address"
      ></p>
      <div *ngIf="editMode">
        <div *ngFor="let address of addresses$ | async; let i = index">
          <app-radio-button-card
            [control]="asFormControl(shippingAddressForm.get('selectedAddressId'))"
            name="selectAddressId"
            [value]="address.id"
            [ariaLabel]="address.line1 || 'Address'"
            [isSelected]="!!(address.id === shippingAddressForm.get('selectedAddressId')?.value)"
            [handleSelect]="changeSelectedAddress.bind(this, address.id)"
          >
            <div slot="header">
              <div class="flex flex-wrap mb-3 -mt-1 sm:mt-0 md:hidden">
                <p-tag
                  *ngFor="let addressType of mapAddressTypeValuesToTagLabels(address.types)"
                  [value]="addressType"
                  styleClass="p-tag-purple p-tag-sm mr-1 my-1"
                  data-cy="shipping-type-tag"
                >
                </p-tag>
              </div>
            </div>
            <div class="flex flex-column w-full md:ml-4">
              <div class="flex">
                <p
                  class="p2 my-0 mb-2 w-full md:w-6 lg:w-4"
                  [innerHTML]="address | formatAddress"
                  data-cy="address"
                ></p>
                <div class="hidden md:flex md:w-6 lg:w-8">
                  <p-tag
                    *ngFor="let addressType of mapAddressTypeValuesToTagLabels(address.types)"
                    [value]="addressType"
                    styleClass="p-tag-purple p-tag-sm mr-1"
                    data-cy="shipping-type-tag"
                  >
                  </p-tag>
                </div>
              </div>
              <div *ngIf="!!(address.id === shippingAddressForm.get('selectedAddressId')?.value)" class="mt-3">
                <div *ngFor="let option of getAddressTypeOptions()">
                  <p-checkbox
                    [label]="option.label"
                    [ngModel]="address.types.includes(option.value)"
                    [binary]="true"
                    [trueValue]="true"
                    [falseValue]="false"
                    [disabled]="address.types.includes(option.value)"
                    styleClass="p-checkbox-sm"
                    ariaLabel="{{ option.label }}"
                    (onChange)="addAddressDefault($event, address.id, option.value)"
                  ></p-checkbox>
                </div>
              </div>
            </div>
          </app-radio-button-card>
        </div>
        <div class="mt-5">
          <app-form-footer
            [submitLabel]="(addPatientAddressTypeState$ | async)?.isLoading ? 'Updating Addresses' : 'Use Address'"
            [disabled]="(addPatientAddressTypeState$ | async)?.isLoading"
            [small]="true"
            [handleCancel]="onCancelshippingAddressForm.bind(this)"
            [handleSubmit]="onSubmitshippingAddressForm.bind(this)"
          ></app-form-footer>
        </div>
      </div>
    </div>
  </p-card>
  <app-wizard-footer
    [disableNav]="editMode || (isBillingStepLoading$ | async) === true"
    [nextLabel]="!!(isBillingStepLoading$ | async) ? 'Updating Order...' : 'Next'"
  ></app-wizard-footer>

  <app-address-form [(visible)]="displayModal" (submitForm)="onAddressCreated($event)"></app-address-form>
</app-content-container>
